<template>
	<button @click="onclick" class="my-auto flex rounded-lg overflow-hidden">
		<div class="flex relative">
			<div class="w-18 flex flex-grow flex-col justify-center" :class="color">
				<slot>
					{{ text }}
				</slot>
			</div>
			<div class="w-6 flex-grow flex flex-col justify-center bg-opacity-10" :class="color">
				<Icon :icon="icon" class="text-green-500 mx-auto" :class="textColor" />
			</div>
		</div>
	</button>
</template>

<script lang="ts" async setup>
	import { Icon } from "@iconify/vue";
	import Button from "~/components/common/button.vue";

	const props = defineProps({
		text: String,
		icon: String,
		color: {
			type: String,
			default: () => "bg-green-500"
		},
		textColor: {
			type: String,
			default: () => "text-green-500"
		},
	});
	
	
	const emit = defineEmits(["click"]);
	
	const onclick = () => emit("click");
</script>
